import React from 'react'

type Props = {
    className?      : string

    option          : Option

    isHighlighted   : boolean
    isSelected      : boolean

    onClick         : func
}

export default function OptionText(props: Props) {

    const onClick = () => {
        props.onClick(props.option)
    }

    const classes = Classes('option', {
        'highlighted': props.isHighlighted
    })

    const valueClass = Classes('label', {
        bold: props.isSelected
    })

    return (
        <div className={classes} onClick={onClick}>
            {!props.option.isAllValuesOption &&
                <div className={Classes("ui5-cb s-16 fl-no-shrink m-r-10", props.className, {selected: props.isSelected})}/>}
            <div className={valueClass}>{props.option.label}</div>
        </div>
    )
}